export default __webpack_public_path__ + "static/media/Grafico2.71636ba2.svg";